import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";


import image1 from "../../../images/service-fluid/3002/FF3002_025_front.png"
import image2 from "../../../images/service-fluid/3002/pictures_FF3002-1_green_front_1200.jpg"
import image3 from "../../../images/service-fluid/3002/pictures_FF3002-5_green_front_1200.jpg"
import image4 from "../../../images/service-fluid/3002/3002_450.png"


const images = [
    { src: image1, alt: "Front" },
     { src: image2, alt: "Back 4L" },
    { src: image3, alt: "Back" },
    { src: image4, alt: "Front 4L" },
   
];

const packageSlides = [
    { images: [image4, image4] },
];

const TDS_URL = "https://www.fanfaro.de/create-pdf/199";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(SK).pdf" }
];

export default function ImageWithContent() {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showSDS, setShowSDS] = useState(false);

    const [packageIndex, setPackageIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

    const slideInterval = useRef(null);
    const slideDuration = 4000;

    useEffect(() => {
        startSlideTimer();
        return () => clearInterval(slideInterval.current);
    }, []);

    const startSlideTimer = () => {
        slideInterval.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, slideDuration);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        clearInterval(slideInterval.current);
        startSlideTimer();
    };

    const nextImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    };

    return (
       <>
         <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "32px",
                padding: "24px",
                fontFamily: "Arial",
            }}
        >

            {/* LEFT IMAGE CAROUSEL */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://www.amazon.in/FANFARO-3002-Performance-Engineered-Motorcycles/dp/B0H4TZW18Y/ref=sr_1_1?crid=1HCXFRA0XCPGI&dib=eyJ2IjoiMSJ9.UON6pzkvXZw8X4G5gU5pPw.wGhs1ik2d_eP5m0zRaCYiT1hGxMT4W8xKWjWTYOsC14&dib_tag=se&keywords=fanfaro+3002&qid=1785752059&s=automotive&sprefix=fanfaro+3002%2Cautomotive%2C284&sr=1-1"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

            {/* RIGHT CONTENT */}
            <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
                <h2>FANFARO Dot-4 Brake Fluid 3002</h2>

                <p>

                   Synthetic brake fluid containing corrosion and oxidation inhibitors. Designed for hydraulic systems of all traditional brake devices and clutches.
                </p>

                <p><strong>Product properties:</strong></p>

                <ul style={{ paddingLeft: "20px" }}>
                    <li>Contains boric acid, which completely neutralizes water condensate.</li>
                    <li> Provides reliable operation of the brake system at any ambient temperature due to the increased boiling point and excellent low-temperature properties.</li>
                    <li>Has the highest chemical and thermal stability.</li>
                    <li>Offers excellent lubricity and viscosity-temperature properties.</li>
                    <li>Neutralizes the formation of vapour bubbles.</li>
                    <li>Compatible with elastomers.</li>
                    <li>Entirely inactive for the parts of the brake system.</li>
                           </ul> <br />
{/* 
                <p>
                    It is designed for petrol-powered 4-stroke engines of motorcycles of all types with air and liquid cooling with or without an integrated gearbox, oil bath clutch coupling and “dry” clutch and other two-wheeled vehicles with the required operating properties of API SN or lower and JASO MA/MA2 level.
                    Comply with the manufacturer’s instructions provided in the user’s manual of the engine, especially the oil replacement age!
                </p> */}


                <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
                    CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
                </p>

                {/* SPECIFICATIONS */}
                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div>
                        <b>Specifications</b>
                        <ul style={{ paddingLeft: "20px" }}>
                            <ul style={{ paddingLeft: "20px" }}>
                                <li>SAE J1703</li>
                                <li>SAE J1704</li>
                                <li>ISO 4925 Class 3</li>
                                <li>ISO 4925 Class 4</li>
                                <li>FMVSS 116 DOT 3</li>
                                <li>FMVSS 116 DOT 4</li>
                                <li>JIS K2233</li>
                            </ul>
                        </ul>
                    </div>


                    <div>
                        <b>Recommendation</b>
                        {/*  */}
                    </div>

                    <div>
                        <b>PACKAGES:</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(0);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                   450ml (FF3002 -450)
                                </span>
                            </li>
{/* 
                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(1);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    20L (FF6208-60)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(2);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    60L (FF6208-DR)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(3);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    208L (FF6208-IBC)
                                </span>
                            </li> */}

                        </ul>
                    </div>
                    <div>
                        <b>SDS & TDS</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowSDS(true);
                                    }}
                                    style={{ textDecoration: "none", cursor: "pointer" }}
                                >
                                    📄 SDS
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://www.fanfaro.de/create-pdf/199"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}>
                                    🖨️ TDS
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>



            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            width: "500px",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >

                        <span
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                                cursor: "pointer",
                                fontSize: "22px",
                            }}
                        >
                            ✕
                        </span>

                        <img
                            src={packageSlides[packageIndex].images[imageIndex]}
                            alt="package"
                            style={{
                                width: "100%",
                                maxHeight: "450px",
                                objectFit: "contain",
                            }}
                        />

                        <div style={{ textAlign: "center", marginTop: "20px" }}>

                            <button onClick={prevImage}>◀</button>

                            <span style={{ margin: "0 15px" }}>
                                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                            </span>

                            <button onClick={nextImage}>▶</button>

                        </div>

                    </div>
                </div>
            )}

            {showSDS && (
                <div className="sds-overlay" onClick={() => setShowSDS(false)}>
                    <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Close Icon */}
                        <button
                            className="sds-close-icon"
                            onClick={() => setShowSDS(false)}
                            aria-label="Close SDS"
                        >
                            ×
                        </button>

                        <h3>Back 4L FANFARO S-4T+ 20W-50</h3>

                        <div className="sds-grid">
                            {SDS_FILES.map((file) => (
                                <a
                                    key={file.code}
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file.code}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>

        <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
       </>
    );
}